(ns frontend.view.grid.screening.subs
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-screening-profile
 (fn [db _]
   (get-in db [:modals :screening-profile])))
